import React from "react";

const Input = ({
  type,
  id,
  placeHolder,
  label,
  name,
  value,
  styling,
  rows,
  cols,
  onChangeHandler,
  autoComplete,
}) => {
  return (
    <div className="flex flex-col sm:gap-2 gap-1 w-full">
      {type === "dropdown" ? (
        <select>{label}</select>
      ) : (
        <label htmlFor={id} className="flex flex-col gap-2 text-white">
          {label}
        </label>
      )}
      {type === "textarea" ? (
        <textarea
          placeholder={placeHolder}
          id={id}
          name={name}
          onChange={onChangeHandler}
          value={value}
          className={styling}
          rows={rows}
          cols={cols}
        />
      ) : type === "dropdown" ? (
        <option
          type={type}
          id={id}
          name={name}
          value={value}
          className={styling}
        />
      ) : (
        <input
          type={type}
          placeholder={placeHolder}
          id={id}
          value={value}
          name={name}
          autoComplete={autoComplete}
          className={styling}
          onChange={onChangeHandler}
        />
      )}
    </div>
  );
};

export default Input;
